// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  TDesktopDeleteAllNotificationsModel,
  IMappers,
  TDesktopDeleteAllNotificationsResponse,
  TDesktopDeleteAllNotificationsResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createDesktopDeleteAllNotificationsModel(): TDesktopDeleteAllNotificationsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'notification-center',
    pathApi: '/v1/desktop/delete-all-notifications/',
    response: {
      '200': {},
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IDesktopDeleteAllNotificationsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchDesktopDeleteAllNotifications<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IDesktopDeleteAllNotificationsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDesktopDeleteAllNotificationsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDesktopDeleteAllNotificationsModel(),
    config,
  )) as FetchResponse<TDesktopDeleteAllNotificationsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TDesktopDeleteAllNotificationsResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDesktopDeleteAllNotificationsResponse>;
}
